import { render, staticRenderFns } from "./repsol-table.component.html?vue&type=template&id=4029a3ff&external"
import script from "./RepsolTableComponent.vue?vue&type=script&lang=ts"
export * from "./RepsolTableComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports